import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FileGateway } from '../gateways';
import { useNotificationContext } from '../context';
import { NotificationActionType } from '../reducers/action-types';
import SuccessNotification from '../components/notifications/success';
import { handleResponse } from '@/core/utils/response';
import { entityKeyFactory, fileKeyFactory } from '@/core/query-keys';

interface MutationProps {
  id: string;
}

async function restoreFile({ id }: MutationProps) {
  return handleResponse(FileGateway.restore({ id }));
}

export function useRestoreFile() {
  const queryClient = useQueryClient();
  const { dispatch } = useNotificationContext();

  const successNotification = (name: string) => (
    <SuccessNotification
      title="Restored"
      onClose={() => {
        dispatch({ type: NotificationActionType.ClosePanel });
      }}
    >
      <p>File {name} was restored successfully.</p>
    </SuccessNotification>
  );

  return useMutation<any, Error, MutationProps, unknown>(restoreFile, {
    onSuccess: () => {
      queryClient.invalidateQueries(entityKeyFactory.all);
      queryClient.invalidateQueries(fileKeyFactory.archived());
      queryClient.invalidateQueries(fileKeyFactory.stats());
    },
    onSettled: ({ name }, error) => {
      if (!error) {
        dispatch({
          type: NotificationActionType.OpenPanel,
          payload: { component: successNotification(name) }
        });
      }
    }
  });
}
